<template>
  <div
    class="lesson-card"
    :class="{ skeleton:loading, disabled:disabled }"
    :style="{
      '--card-width-mobile': cardWidthMobile,
      '--card-width-desktop': cardWidthDesktop
    }"
  >
    <div class="lesson-icon">
      <div class="icon-circle">
        <img
          :src="iconAttachmentUrl"
          alt=""
        />
      </div>
    </div>

    <div>
      <div class="text-xl font-semibold">
        {{ lesson.name }}
      </div>
      <div class="text-xs font-semibold question-count">
        {{ countMessage }}
      </div>
    </div>

    <div class="text-md font-normal">
      {{ lesson.description }}
    </div>

    <button
      class="lesson-button"
      :disabled="disabled"
      @click="$emit('lesson-click', lesson)"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import {
  LESSON_CARD_WIDTH_MOBILE,
  LESSON_CARD_WIDTH_DESKTOP,
} from '@/utils/lessonWidgetConstants';

export default {
  name: 'LessonWidgetCard',
  props: {
    iconAttachment: {
      type: Object,
      required: true,
    },
    lesson: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  emits: ['lesson-click'],
  computed: {
    cardWidthMobile() {
      return `${LESSON_CARD_WIDTH_MOBILE}px`;
    },
    cardWidthDesktop() {
      return `${LESSON_CARD_WIDTH_DESKTOP}px`;
    },
    countMessage() {
      if (this.numberOfFlashcards === 0) {
        return '';
      }
      return `${this.numberOfFlashcards} ${this.numberOfFlashcards === 1 ? 'question' : 'questions'}`;
    },
    disabled() {
      return this.lesson.disabled;
    },
    iconAttachmentUrl() {
      return this.iconAttachment?.url;
    },
    numberOfFlashcards() {
      return this.lesson.flashcardIds ? this.lesson.flashcardIds.length : 0;
    },
  },
};
</script>

<style scoped lang="scss">

.question-count {
  opacity: 0.6;
  min-height: 20px;
}

.lesson-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  border-radius: 10px;
  background-color: var(--bg-widget-primary);
  color: white;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  text-align: center;
  gap: rem-calc(12);
  min-height: 280px;
  width: var(--card-width-mobile);
  box-sizing: border-box;
  flex-shrink: 0;
  justify-content: space-between;

  @include breakpoint(desktop) {
    width: var(--card-width-desktop);
  }
}

.lesson-card.skeleton {
  background-color: #f5f5f5;
  color: #f5f5f5;

  .lesson-icon {
    background-color: #999;
    border-color: #999;
    opacity: 0.3;
  }
}

.lesson-icon {
  margin-top: 8px;
  border-radius: var(--radius-full);
}

.icon-circle {
  width: 50px;
  height: 50px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bg-widget-primary);
}

.lesson-button {
  width: 100%;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background-color: #333333;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.disabled {
  .lesson-button {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.lesson-button:hover {
  background-color: #222222;
}

.lesson-button:active {
  background-color: #111111;
}
</style>
